import { Model } from './model';

export class ExecutionConfigModel implements Model {
  hub_ip: string;
  port: number;
  default_pause: string;
  send_mail: boolean;
  browser: string[];
  resolution: string;
  screenshot_required: boolean;
  default_hub: boolean;
  local_execution: boolean;
  execution_machine: string;
  is_url_without_port: boolean;
  selected_option?: string;
  is_user_hub?: boolean;
  xDimension?: number;
  yDimension?: number;
  license_id?: string;
}